import FilterIconAll from '@pancakeswap/uikit/components/Svg/Icons/FilterIconAll'
import FilterIconDocs from '@pancakeswap/uikit/components/Svg/Icons/FilterIconDocs'
import FilterIconTokens from '@pancakeswap/uikit/components/Svg/Icons/FilterIconTokens'
import SideIconExplore from '@pancakeswap/uikit/components/Svg/Icons/SideIconExplore'
import SideIconHome from '@pancakeswap/uikit/components/Svg/Icons/SideIconHome'

export const filterMenuConfig = [
  {
    label: 'VIEW ALL',
    icon: FilterIconAll,
  },
  {
    label: 'APPS',
    icon: SideIconExplore,
  },
  {
    label: 'TOKENS',
    icon: FilterIconTokens,
  },
  {
    label: 'DOCS',
    icon: FilterIconDocs,
  },
  {
    label: 'ADDRESSES',
    icon: SideIconHome,
  },
]
